module.exports = __webpack_public_path__ + "img/lg_ring_y_c_1_0@2x.58e4c273.png";